<template>

        <div class="c-avatar ml-3">
          <img
              v-bind:src="user_image"
            class="c-avatar-img "
          />
        </div>
  
</template>

<script>
export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return {
      itemsCount: 42,
      user_name: "",
      user_image: "/img/user.png",
    }
  },
  methods:{
      go_login(){

          localStorage.setItem('token','');
          this.$router.push({ path: '/dashboard/login'});
      },
        get_user_name(){


            this.user_name= localStorage.getItem("user_name")
            // this.user_image= this.$store.state.user_image;



            // alert(res.contains("Sam"));

          // this.$router.push({ path: '/login'});
      }
    },computed: {

    },
  mounted() {
    this.user_image =  localStorage.getItem('image');

        setTimeout(() =>
            this.get_user_name()
            , 1000);

    }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
